import request from '@/util/request';
import qs from 'qs';

// export const getList = (params, options) =>
// request.get('/api/deviceinspectplan/list', Object.assign({}, options, { params }));

export const getList = (params, options) =>
request.get('/api/deviceinspectplan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/deviceinspectplan/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/deviceinspectplan/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/deviceinspectplan/submit', params,options)

export const update = (params, options) =>
request.post('/api/deviceinspectplan/submit', params,options)


// 获取设备
export const getDeviceList = (params, options) =>
request.get('/api/device/queryList', Object.assign({}, options, { params }))

// 获取设备
export const getStandardList = (params, options) =>
request.get('/api/deviceinspectstandard/getStandardByDeviceId', Object.assign({}, options, { params }))


export const saveInspectPlan = (params, options) =>
request.post('/api/deviceinspectplan/save', params, options)

export const updateInspectPlan = (params, options) =>
request.post('/api/deviceinspectplan/update', params, options)

// 获取设备
export const getInspectCycleTypeDicData = (params, options) =>
request.get('/api/blade-system/dict/dictionary?code=inspect_cycle_type', Object.assign({}, options, { params }))



